<template>
  <div class="sort-list">
    <div class="list-wrapper" @scroll.passive="handleScollDebounce($event)" ref="listWrapper">
      <div class="list-content">
        <template>
          <ListItem :item="item" v-for="item in list" :key="item.id" @toDetail="$emit('toDetail', item.id)" @likesAdd="
            (id, type) => {
              $emit('likesAdd', id, type);
            }
          "></ListItem>
          <div style="text-align: center;color: #d9d9d9;padding: 20px;" v-text="this.showMoreDesc"></div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import ListItem from "./Listitem.vue";
import { debounce } from 'lodash';
export default {
  name: "sort-list",
  props: {
    list: {
      type: Array,
    },
    current: {
      type: Number,
    },
    pageSize: {
      type: Number
    },
    total: {
      type: Number
    },
    byTitle: {
      type: Number
    }
  },
  components: {
    ListItem,
  },
  computed: {
    showMoreDesc() {
      if (Math.ceil(this.total / this.pageSize) === this.page) {
        return "无更多数据";
      } else if (this.total == 0) {
        if (this.byTitle == 1) {
          return "暂无数据，建议通过全文搜索查找所需内容";
        } else {
          return "暂无数据";
        }
      }
      return "";
    }
  },
  watch: {
    current: function (newVal) {
      this.page = newVal;
    }
  },
  data() {
    return {
      page: this.current,
      maxPage: Math.ceil(this.total / this.pageSize),
    };
  },
  methods: {

    /**
     * 点击打开详情页弹窗
     */
    toDetail(id) {
      this.$emit("toDetail", id);
    },
    //监听滚动条距离
    handleScollDebounce: debounce(function (event) {
      this.handleScoll(event)
      // this.handleScollTest(event);
    }, 100),
    //滚动条触底时请求数据
    handleScoll(event) {
      // console.log(event.target.scrollHeight , event.target.scrollTop);
      if (event.target.scrollHeight - event.target.scrollTop <= 1400) {
        if (this.page < Math.ceil(this.total / this.pageSize) && event.target.scrollHeight !== event.target.clientHeight) {
          this.$emit('change', ++this.page, this.pageSize)
        }
      }
    },
  },
};
</script>
<style scoped lang="scss">
/* 滚动条背景色 */
::-webkit-scrollbar-track-piece {
  background-color: #fff;
}

.sort-list {
  flex: 1;
  overflow: hidden;
}

.sort-bar-table {
  width: 100%;
  padding: 0 52px;
  border-bottom: 1px solid #f6f6f6;
  margin-left: -16px;
}

.sort-bar {
  width: 360px;
  /* height: 40px; */
  white-space: nowrap;
}

::v-deep .ant-table-placeholder,
::v-deep .ant-table-tbody {
  display: none;
}

::v-deep .ant-table-thead>tr>th.ant-table-column-sort {
  background: none;
}

::v-deep .ant-table-thead>tr>th.ant-table-column-has-actions.ant-table-column-has-sorters:hover {
  background: none;
  color: #0077ff;
}

::v-deep .ant-table-column-has-actions.ant-table-column-has-sorters.ant-table-column-sort {
  color: #0077ff;
}

::v-deep .ant-table-thead>tr>th {
  color: #333;
  border-bottom: none;
}

::v-deep table tr th {
  background: none;
}

::v-deep .ant-table-thead>tr>th .ant-table-header-column .ant-table-column-sorters:hover::before {
  background: none;
}

.list-wrapper {
  height: 100%;
  overflow-x: hidden;
}

.list-content {
  padding: 0 30px;
}

@media screen and (max-width: 1024px) {
  .sort-bar-table {
    padding: 0 16px;
  }
}

@media screen and (max-width: 824px) {
  .list-content {
    padding: 0 10px;
  }
}
</style>